<template>
  <div style="width: 100vw; overflow: hidden">
    <div v-if="this.$store.state.abaSelecionada == 'loading'">
      <div class="loading-buscando-menu-promocao">
        <img
          :src="this.$store.state.logo"
          alt=""
          id="loading-buscando-menu-promocao-back"
        />
        <img
          src="../assets/loading.gif"
          alt=""
          id="loading-buscando-menu-promocao-loading-icon"
        />
        <!-- <img :src="this.$store.state.logo" alt="" id="loading-buscando-menu-promocao-logo"> -->
        <br />
        <br />
        <h3>Atualizando menu</h3>
        <br />

        <div style="max-width: 70%; line-height: 1.5">
          <p>Por favor, aguarde alguns segundos.</p>
          <p>
            Estamos atualizando os dados de promoção e disponibilidade de itens.
          </p>
        </div>
      </div>
    </div>

    <div
      class="background-aqui"
      v-if="this.$store.state.abaSelecionada != 'loading'"
      style="overflow: hidden"
    >
      <!-- menu top          -->
      <div class="menu-top">
        <MenuTop />
      </div>

      <!-- CENTRO          -->
      <div
        v-if="this.$store.state.abaSelecionada == 'destaques'"
        class="div-classes-e-items"
        style="display: block; overflow: hidden"
      >
        <AbaDestaques />
      </div>

      <div
        v-if="this.$store.state.abaSelecionada == 'cardapio'"
        class="div-classes-e-items"
        style="display: flex; overflow: hidden"
      >
        <div class="menu-classes" style="overflow: hidden; overflow-y: scroll" ref="MenuClassesDiv">
          <MenuClasses />
        </div>
        <div
          class="itens"
          style="overflow: hidden; overflow-y: scroll"
          ref="ListaItensVendaDiv"
        >
          <ListaItensVenda ref="listaItensVendaRef" />
        </div>
      </div>

      <div
        v-if="this.$store.state.abaSelecionada == 'carrinho'"
        class="div-classes-e-items"
        style="display: block; overflow: hidden"
      >
        <CarrinhoView @AtualizaStatusBotaoEnviarPedido="atualizarBloqueio" />
      </div>

      <!-- menu baixo          -->
      <div class="menu-bottom" :class="{ 'menu-bottom-oculto': menuBaixoOculto }">
        <div v-if="this.$store.state.abaSelecionada == 'carrinho'">
          <div>
            <BottomBarCarrinho
              :valorFinalTotal="getFinalTotal"
              :podeEnviar="podeEnviar && !bloquearEnquantoRespondePopup"
              :onClickConfirmar="onClickEnviar"
            />
          </div>
        </div>

        <MenuBaixo />
        <!-- <MenuBaixo 
                :onClickCardapio="onClickCardapio" 
                :onClickDestaques="onClickDestaques" 
                :onClickCarrinho="onClickCarrinho"
            /> -->
      </div>

      <router-view />
    </div>
  </div>
</template>

<script>
import MenuClasses from "../components/CardapioView/MenuClasses.vue";
import ListaItensVenda from "../components/CardapioView/ListaItensVenda.vue";
import MenuTop from "../components/CardapioView/MenuTop.vue";
import MenuBaixo from "../components/CardapioView/MenuBaixo.vue";
import AbaDestaques from "../views/AbaDestaques.vue";
import { setarCores } from "../utils/SetarCores";
import CarrinhoView from "./CarrinhoView.vue";
import { mapGetters } from "vuex";
import BottomBarCarrinho from "@/components/Carrinho/BottomBarCarrinho.vue";

export default {
  name: "CardapioView",
  data() {
    return {
      podeEnviar: true,
      bloquearEnquantoRespondePopup: false,
      menuBaixoOculto: false,
    };
  },
  /**
   * Recarrega fonte e aplica globalmente.`
   */
  mounted() {
    const savedFont = sessionStorage.getItem("font-guardada-session");
    if (savedFont) {
      document.documentElement.style.setProperty(
        "--font-family",
        `'${savedFont}', sans-serif`
      );
    }
    if (this.$store.state.abaSelecionada === 'cardapio') {
      this.$nextTick(() => this.adicionarScrollListeners());
    }
    // Registra o estado atual no histórico para que o popstate funcione na primeira volta
    window.history.replaceState(
      { aba: this.$store.state.abaSelecionada },
      '',
      window.location.href
    );
    window.addEventListener('popstate', this._onPopstate);
  },

  beforeDestroy() {
    this.removerScrollListeners();
    window.removeEventListener('popstate', this._onPopstate);
  },

  components: {
    MenuClasses,
    ListaItensVenda,
    MenuTop,
    MenuBaixo,
    AbaDestaques,
    CarrinhoView,
    BottomBarCarrinho,
  },
  created() {
    setarCores(this.$store.state.cor1, this.$store.state.cor2, this.$store.state.corTexto),
      this.setarPodeEnviar();
  },

  watch: {
    /** calcula o total final assim que a tela renderiza */
    getFinalTotal() {
      if (this.getFinalTotal == 0.0) {
        this.podeEnviar = false;
      }
    },

    carrinho() {
      this.setarPodeEnviar();
    },
    abaSelecionadaAtualizada(nova) {
      if (nova === 'cardapio') {
        this.$nextTick(() => this.adicionarScrollListeners());
      } else {
        this.removerScrollListeners();
        this.menuBaixoOculto = false;
      }
      this.bloquearEnquantoRespondePopup = false;
    },

    //zera o scroll da lista de itens
    classeSelecionadaAtualizada() {
      this.$nextTick(() => {
        const container = this.$refs.ListaItensVendaDiv;
        if (container) {
          container.scrollTop = 0;
        }
      });
      this.menuBaixoOculto = false;
    },
  },

  computed: {
    ...mapGetters({
      carrinho: "getItensCarrinho",
      casaAberta: "getCasaAberta",
    }),

    getFinalTotal: function () {
      return this.calcularValorTotalFinal()
        .toFixed(2)
        .replace(".", ",")
        .replace(".", ",");
    },
    //essa variavel eh usada no watch para zerar o scroll
    classeSelecionadaAtualizada() {
      return this.$store.state.classeSelecionada;
    },

    abaSelecionadaAtualizada() {
      return this.$store.state.abaSelecionada;
    },
  },

  methods: {
    _onPopstate(event) {
      const aba = event.state?.aba;
      const abasValidas = ['cardapio', 'destaques', 'carrinho'];
      if (aba && abasValidas.includes(aba)) {
        this.$store.commit('SET_ABA_SELECIONADA', aba);
      }
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    handleScroll(event) {
      const carrinhoVazio = this.$store.state.itensCarrinho.length === 0;
      const el = event.target;
      const scrollAtual = el.scrollTop;
      const scrollAnterior = el._scrollAnterior || 0;

      if (scrollAtual > scrollAnterior && scrollAtual > 10 && carrinhoVazio) {
        this.menuBaixoOculto = true;
      } else if (scrollAtual < scrollAnterior) {
        this.menuBaixoOculto = false;
      }

      el._scrollAnterior = scrollAtual;
    },

    adicionarScrollListeners() {
      this.removerScrollListeners(); // garante que não duplica
      const menuClasses = this.$refs.MenuClassesDiv;
      const itens = this.$refs.ListaItensVendaDiv;
      if (menuClasses) menuClasses.addEventListener('scroll', this.handleScroll);
      if (itens) itens.addEventListener('scroll', this.handleScroll);
    },

    removerScrollListeners() {
      const menuClasses = this.$refs.MenuClassesDiv;
      const itens = this.$refs.ListaItensVendaDiv;
      if (menuClasses) menuClasses.removeEventListener('scroll', this.handleScroll);
      if (itens) itens.removeEventListener('scroll', this.handleScroll);
    },

    onClickEnviar() {
      this.$store.dispatch("setOnCLickEnviarPedido");
    },

    calcularValorTotalFinal() {
      let finalPrecoTotal = 0.0;
      for (var i = 0; i < this.carrinho.length; i++) {
        console.log(`preco item ${i} :: ${this.carrinho[i].preco}`);
        console.log(this.carrinho[i]);
        finalPrecoTotal =
          finalPrecoTotal +
          parseFloat(this.carrinho[i].precoTotal) * this.carrinho[i].quantidade;
      }
      return finalPrecoTotal;
    },

    /**
     * vai alterar a var podeEnviar para true ou false dependendo do getFinalTotal
     * @see podeEnviar
     * @see getFinalTotal
     */
    setarPodeEnviar() {
      if (this.carrinho == null || this.carrinho.length == 0) {
        this.podeEnviar = false;
      } else {
        this.podeEnviar = true;
      }
    },

    atualizarBloqueio(Valor) {
      this.bloquearEnquantoRespondePopup = Valor;
    },
  },
};
</script>

<style scoped>
.background-aqui {
  width: 100%;
  background: var(--cor-background);
}
.menu-top {
  position: fixed;
  z-index: 100;
  width: 100%;
  height: var(--altura-menu-padrao);
}

.menu-bottom {
  position: fixed;
  bottom: 0px;
  z-index: 100;
  width: 100%;
  transition: transform 0.3s ease;
}

.menu-bottom-oculto {
  transform: translateY(100%);
}

.div-classes-e-items {
  padding-top: var(--altura-menu-padrao);
  min-height: calc(100vh - var(--altura-menu-padrao));
  max-height: calc(100vh - var(--altura-menu-padrao));
}

.menu-classes {
}
@media only screen and (max-width: 720px) {
  .menu-classes {
    width: 20vw;
  }
  .itens {
    flex: 1;
  }
}

/* desktop */
@media only screen and (min-width: 720px) {
  .div-classes-e-items {
    width: 100%;
  }
  .menu-classes {
    background: transparent;
  }
  .itens {
    padding-inline: 10px;
    flex: 1;
  }
}

.itens {
  background: var(--cor-background);
}

.loading-buscando-menu-promocao {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100dvh;
  color: white;
  position: relative;
  background: linear-gradient(to top, var(--cor1-muito-escura), transparent);
  animation: loading-buscando-menu-promocao-anim-entrada 1s forwards;
}
@keyframes loading-buscando-menu-promocao-anim-entrada {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
#loading-buscando-menu-promocao-back {
  position: absolute;
  z-index: -1;
  filter: blur(5px);
  opacity: 0.2;
}

#loading-buscando-menu-promocao-logo {
  width: 40%;
  animation: loading-buscando-menu-promocao-logo-anim 2s infinite;
}
@keyframes loading-buscando-menu-promocao-logo-anim {
  0%,
  100% {
    scale: 100%;
  }
  50% {
    scale: 80%;
  }
}
</style>
